var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTreeFolder = function SvgTreeFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFC700",
    stroke: "#222",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#treeFolder_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.333 6.5a1 1 0 0 1 1-1h6.084a1 1 0 0 1 .923.615l.737 1.77A1 1 0 0 0 14 8.5h7.333a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.604 12.717A1 1 0 0 1 2.58 11.5H18.53a1 1 0 0 1 .976.783l1.556 7a1 1 0 0 1-.976 1.217H4.135a1 1 0 0 1-.976-.783z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "treeFolder_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.333.5h24v24h-24z"
  })))));
};
export default SvgTreeFolder;